export default "__VITE_ASSET__JG1hXvUX__"